import { render } from "./Partners.vue?vue&type=template&id=66c6b05c"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"
script.render = render

export default script